<template>
	<div class="manage-nfl-weekly-pickem-entry-page">
		<div class="manage-nfl-weekly-pickem-entry-page__content">
			<div class="entry-data" v-if="entry !== null">
				<h3 class="entry-name">{{ entryName }}</h3>
				<div class="header-row">
					<select class="week-select" v-model="selectedWeek" @change="changeWeek">
						<option value="0" v-if="selectedWeek == 0"></option>
						<option v-for="index in numberOfWeeks" :key="index" :value="index">Week {{ index }}</option>
					</select>
					<button class="save-button" @click="updatePicks" :disabled="selectedWeek == 0">Save</button>
				</div>

				<div class="team-header">
					<p>Away</p>
					<p>Home</p>
				</div>
				
				<div class="game-row" v-for="(game, index) in sortedGames" :key="index">
					<div class="away-team" @click="pickMade(index, game.away_participant.id)" :class="{active: (picks[index][0] == game.away_participant.id), 'radio-disabled': game.game_underway == 1}">
						<input class="pick-radio" type="radio" :name="'game' + index" :value="game.away_participant.id" v-model="picks[index][0]" :disabled="game.game_underway == 1">
						<p>{{ game.away_participant.team.location }} {{ game.away_participant.team.nickname }}</p>
					</div>
					<div class="home-team" @click="pickMade(index, game.home_participant.id)" :class="{active: (picks[index][0] == game.home_participant.id),  'radio-disabled': game.game_underway == 1}">
						<p>{{ game.home_participant.team.location }} {{ game.home_participant.team.nickname }}</p>
						<input class="pick-radio" type="radio" :name="'game' + index" :value="game.home_participant.id" v-model="picks[index][0]" :disabled="game.game_underway == 1">
					</div>
				</div>
			</div>
		</div>

		<div class="popup" v-if="showSaveSuccessfull">
			<div class="popup__content">
				<p class="font-size--medium">Entry Saved Successfully!</p>
				<div class="popup__content--bottom">
					<button class="font-size--medium text-color--secondary" @click="showSaveSuccessfull = false">Close</button>
				</div>	
			</div>
		</div>
	</div>
</template>

<script>
	import { mapMutations } from 'vuex'
	import axios from '@/axios'

	export default {
		props: [ 'poolId', 'entryId', 'weekId' ],
		data() {
			return {
				pool: null,
				entry: null,
				entryWeek: null,
				selectedWeek: 0,
				picks: [],
				showSaveSuccessfull: false
			}
		},
		computed: {
			entryName() {
				var name = ''
				if(this.entry !== null) {
					this.entry.users.forEach((user, index) => {
						if (index == 0) {
							name = user.user.name
						} else if (index == this.entry.users.length - 1 && this.entry.users.length > 2) {
							name = name.concat(user.user.name)
						} else {
							name = name.concat(' / ').concat(user.user.name)
						}
					})
				}
				return name
			},
			numberOfWeeks() {
				var numberOfWeeks = 17
				if(this.pool != null) {
					numberOfWeeks = this.pool.nfl_season.number_of_weeks
				}
				return numberOfWeeks
			},
			sortedGames() {
				if (this.entryWeek !== null) {
					var picks = this.entryWeek.picks
					return picks.sort(function(a,b) {
						return a.date_time - b.date_time
					})
				} else {
					return []
				}
			}
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED'
			]),
			pickMade(game, pick) {
				if (this.sortedGames[game].game_underway == 0) {
					this.picks.splice(game, 1, [pick])
				}
				
			},
			changeWeek() {
				var weekId
				this.entry.weeks.forEach((week) => {
					if (week.week_number == this.selectedWeek) {
						weekId = week.id
					}
				})
				this.HTTP_IN_PROGRESS()
				this.getEntryWeek(weekId).then(() => {
					this.HTTP_FINISHED()
				})
			},
			getNflWeeklyPickem() {
				return axios.get('nfl-weekly-pickems/' + this.poolId).then((response) => {
					this.pool = response.data.data
					this.selectedWeek = this.pool.nfl_season.current_nfl_week.week_number
				})
			},
			getEntry() {
				return axios.get('nfl-weekly-pickems/' + this.poolId + '/nfl-weekly-pickem-entries/' + this.entryId).then((response) => {
					this.entry = response.data.data
				})
			},
			getEntryWeek(weekId) {
				return axios.get('nfl-weekly-pickems/' + this.poolId + '/nfl-weekly-pickem-entries/' + this.entryId + '/nfl-weekly-pickem-entry-week/' + weekId).then((response) => {
					this.entryWeek = response.data.data
					this.setPicks()
				})
			},
			setPicks() {
				this.sortedGames.forEach((game, index) => {
					this.picks[index] = [null]
				})
				this.sortedGames.forEach((game, index) => {
					this.picks.splice(index, 1, [game.pick_id])
				})
			},
			updatePicks() {
				var picks = []
				this.sortedGames.forEach((game, index) => {
					picks.push({
						nfl_regular_season_game_id: game.nfl_regular_season_game_id,
						pick_id: this.picks[index][0]
					})
				})

				var data = {
					data: {
						picks: picks
					}
				}

				this.HTTP_IN_PROGRESS()
				axios.patch('nfl-weekly-pickems/' + this.poolId + '/nfl-weekly-pickem-entries/' + this.entryId + '/nfl-weekly-pickem-entry-week/' + this.entryWeek.id, data).then((response) => {
					this.entryWeek = response.data.data
					this.setPicks()
					this.showSaveSuccessfull = true
					this.HTTP_FINISHED()
				})

			}
		},
		created() {
			this.HTTP_IN_PROGRESS()
			this.getNflWeeklyPickem().then(() => {
				this.getEntry().then(() => {
					if(this.weekId) {
						this.getEntryWeek(this.weekId).then(() => {
							this.HTTP_FINISHED()
						})
					} else {
						this.selectedWeek = 0
						this.HTTP_FINISHED()
					}
					
				})
			}).catch(() => {
				this.HTTP_FINISHED()
				this.$router.replace('/')
			})
		},
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../styles/views/nfl/nfl-weekly-pickem/manageEntry';
</style>


